// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__DUEUW","question-mark":"icon_question-mark__qeNuV"};